
(function () {

    'use strict';
    angular.module('app').controller('forceSsoModalController', forceSsoModalController);

    forceSsoModalController.$inject = ['$scope'];

    function forceSsoModalController($scope) {

        $scope.ok = function () {
            $scope.$close();
        };

    }

    angular.module('app')
        .controller('forceSSOController',
            [
                '$location',
                '$routeParams',
                '$timeout',
                '$rootScope',
                '$uibModal',
                'forceSSOService',
                forceSSOController
            ]
        );

    function forceSSOController($location, $routeParams, $timeout, $rootScope, $uibModal, forceSSOService) {
       
        $rootScope.showLogo = true;
        var vm = this;
        vm.clientToken = $routeParams.ct;
        vm.waiting = true;
        vm.run = function() {


            forceSSOService.create(vm.clientToken).then(
                function(response) {
                    if (!response) {
                        vm.error = true;

                        vm.waiting = false;

                    } else {
                        vm.response = response;
                        vm.response.loginUrl += "&firstRun=1";

                        vm.waiting = false;
                    }
                },
                function(response) {
                    vm.error = true;

                    vm.waiting = false;

                }
            );
        };
        vm.showModal = function () {

            var modalInstance = $uibModal.open({
                ariaLabelledBy: 'modal-title-bottom',
                ariaDescribedBy: 'modal-body-bottom',
                templateUrl: './assets/templates/modals/ForcedSsoModal.html',
                size: 'md',
                controller: forceSsoModalController
            });

            modalInstance.result.then(function () {
                    vm.acknowledged = true;
                    vm.run();
            }, function() {
                    vm.showModal();
                }
            );
        };
        vm.showModal();
    }
})();